import * as React from 'react';
import style from './RelatedContentList.scss';
import { RelatedContentIcons } from '../RelatedContentIcons';
import { ExternalLink } from '../../../PageElements/ExternalLink';
import { LoggerContext } from '../../../../appContext/LoggerProvider';
import { NAV_TYPES } from '../../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { StoreContext } from '../../../../appContext/StoreProvider';
import { logNavigationClickFromLink } from '../../../../LoggerFactory/BiAnalyticsLogger/events';

export const RelatedContentList = ({ relatedContentList }) => {
  const { logger } = React.useContext(LoggerContext);
  const { store } = React.useContext(StoreContext);
  const onLinkClick = (url) => () => {
    logNavigationClickFromLink(logger, url, store, NAV_TYPES.INDEX_PAGE);
  };

  return (
    <div className={style['related-content-links']}>
      {relatedContentList.map(({ text, icon, url }) => (
        <span
          key={text}
          className={style['related-content-link']}
          onClick={onLinkClick(url)}
        >
          <RelatedContentIcons iconName={icon} />
          <ExternalLink to={url} size="small" weight="normal">
            {text}
          </ExternalLink>
        </span>
      ))}
    </div>
  );
};
